import React from 'react'
import CoinMarket from './CoinMarket';
import WalletCards from '../Wallet/WalletCards';

const Index = () => {
  return (
    <>
    {/* <BalanceCard/> */}
    
    {/* <PyramidData/> */}
    {/* <MobileMenu/> */}
    
    <CoinMarket/>
    <WalletCards/>
    </>
  )
}

export default Index
